var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-tabs',[_c('v-tab',{attrs:{"ripple":""}},[_vm._v("Modèles")]),_c('v-tab-item',[_c('templates-table')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }